import { Helmet } from "react-helmet-async"
import React from "react"
import { observer } from "mobx-react-lite"
import { Container, Flex, createStyles, Group } from "@mantine/core"
import { PageTitle } from "shared/ui/PageTitle"
import { ScheduleTypeToggler } from "features/schedule"
import { ScheduleList } from "widgets/schedule"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}))

// ----------------------------------------------------------------------

export const ScheduleListPage = observer(function ScheduleListPage() {
  const { classes } = useStyles()
  const url = new URL(window.location.href)

  return (
    <>
      <Helmet>
        <title>BodyCoach - Расписание</title>
        <meta property="og:title" content="BodyCoach - Расписание"/>

        <meta name="description"
              content="Расписание курсов и тренингов образовательной платформы Body Coach"/>
        <meta property="og:description"
              content="Расписание курсов и тренингов образовательной платформы Body Coach"/>

        <meta property="og:url" content={url.href}/>
        <link rel="canonical" href={url.href}/>
        <meta property="og:site_name" content={url.host}/>
        <meta name="robots" content="index, follow"/>

        <meta name="keywords"
              content="расписание занятий, программа боди коуч, боди коч график, расписание занятий body coach, профессии боди коуч, "/>
      </Helmet>

      <Container size="xl" className={classes.container}>
        <PageTitle title="Расписание курсов и тренингов"/>

        <Flex direction="column">
          <Group>
            <ScheduleTypeToggler/>
          </Group>

          <ScheduleList/>
        </Flex>
      </Container>
    </>
  )
})
